import { Config, system } from 'styled-system';

export const p = system({
  p: {
    property: 'padding',
    scale: 'space',
  },
});

const configMarginY: Config = {
  marginY: {
    properties: ['marginTop', 'marginBottom'],
    scale: 'space',
  },
  marginBottom: {
    property: 'marginBottom',
    scale: 'space',
  },
  marginTop: {
    property: 'marginTop',
    scale: 'space',
  },
};

configMarginY.my = configMarginY.marginY;
configMarginY.mt = configMarginY.marginTop;
configMarginY.mb = configMarginY.marginBottom;

export const marginY = system(configMarginY);
